module.exports = __webpack_public_path__ + "img/维修成本@3x.56ae5983.png";